var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.shouldShow
    ? _c("div", { staticClass: "frequent-questions" }, [
        _c(
          "div",
          {
            staticClass: "floating-container",
            class: { collapsed: _vm.isCollapsed },
            on: { mouseenter: _vm.showContent, mouseleave: _vm.hideContent },
          },
          [
            !_vm.isCollapsed
              ? _c("div", { staticClass: "question-content" }, [
                  _vm._m(0),
                  _c(
                    "div",
                    { staticClass: "question-body" },
                    [
                      _c("p", { staticClass: "question-text" }, [
                        _vm._v("遇到问题了？"),
                      ]),
                      _c("p", { staticClass: "question-text" }, [
                        _vm._v("点击查看帮助文档"),
                      ]),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.handleClick },
                        },
                        [_vm._v("查看帮助")]
                      ),
                    ],
                    1
                  ),
                ])
              : _c("div", { staticClass: "collapsed-content" }, [
                  _c("i", { staticClass: "el-icon-question" }),
                  _c("span", { staticClass: "collapsed-text" }, [
                    _vm._v("常见问题"),
                  ]),
                ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "question-header" }, [
      _c("i", { staticClass: "el-icon-question" }),
      _c("span", { staticClass: "question-title" }, [_vm._v("常见问题")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }